import React from 'react';
import Logo from './company/Logo';
import FooterLinks from './footer/FooterLinks';
import FooterContact from './footer/FooterContact';
import FooterCopyright from './footer/FooterCopyright';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <Logo size="sm" className="mb-4" />
            <p className="mt-4 text-gray-400">
              Expert open source solutions for enterprises. Implementation, migration, and training services to optimize your infrastructure.
            </p>
          </div>
          <FooterLinks />
          <FooterContact />
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-800">
          <FooterCopyright />
        </div>
      </div>
    </footer>
  );
};

export default Footer;